import React from "react";
import graduationIcon from "../Assests/graduation.png";
import testicon from "../Assests/turing-test.png";
import analyticsIcon from "../Assests/analytics.png";
import doubtIcon from "../Assests/problem.png";


const HeroFeatures = () => {
  const features = [
    {
      id: 1,
      icon: graduationIcon,
      title: "Expert Faculty",
      subtitle: "Learn from experienced professors and subject matter experts.",
    },
    {
      id: 2,
      icon: testicon,
      title: "Interactive Tests",
      subtitle: "Take 3500+ chapter-wise tests, mock exams, and live quizzes",
    },
    {
      id: 3,
      icon: doubtIcon,
      title: "Doubt Solving",
      subtitle: "Get your doubts resolved by faculty support",
    },
    {
      id: 4,
      icon: analyticsIcon,
      title: "Smart Analytics",
      subtitle: "Get instant performance analytics and track your progress",
    },
  ];

  return (
    <div className="w-full flex justify-center px-4 -mt-16 relative z-20">
      <div className="bg-white shadow-xl rounded-2xl p-6 w-full max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((item) => (
          <div key={item.id} className="flex flex-col items-center text-center">
            <img src={item.icon} alt={item.title} className="h-12 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
            <p className="text-gray-600 text-sm">{item.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroFeatures;
